export var BasketItemType;
(function (BasketItemType) {
    BasketItemType["Deal"] = "DEAL";
    BasketItemType["Reward"] = "REWARD";
    BasketItemType["EntityTypeUnknown"] = "ENTITY_TYPE_UNKNOWN";
    BasketItemType["Unrecognized"] = "UNRECOGNIZED";
})(BasketItemType || (BasketItemType = {}));
export var BusinessMetadataHomePageWidgetTypes;
(function (BusinessMetadataHomePageWidgetTypes) {
    BusinessMetadataHomePageWidgetTypes["Image"] = "image";
    BusinessMetadataHomePageWidgetTypes["ImageWithText"] = "imageWithText";
    BusinessMetadataHomePageWidgetTypes["Video"] = "video";
})(BusinessMetadataHomePageWidgetTypes || (BusinessMetadataHomePageWidgetTypes = {}));
export var CacheControlScope;
(function (CacheControlScope) {
    CacheControlScope["Public"] = "PUBLIC";
    CacheControlScope["Private"] = "PRIVATE";
})(CacheControlScope || (CacheControlScope = {}));
export var CheckoutStatus;
(function (CheckoutStatus) {
    CheckoutStatus["StatusUnknown"] = "STATUS_UNKNOWN";
    CheckoutStatus["Started"] = "STARTED";
    CheckoutStatus["Redeeming"] = "REDEEMING";
    CheckoutStatus["Completed"] = "COMPLETED";
    CheckoutStatus["Failed"] = "FAILED";
    CheckoutStatus["Unrecognized"] = "UNRECOGNIZED";
})(CheckoutStatus || (CheckoutStatus = {}));
export var CompanyNewsTileType;
(function (CompanyNewsTileType) {
    CompanyNewsTileType["Empty"] = "empty";
    CompanyNewsTileType["Image"] = "image";
    CompanyNewsTileType["Template"] = "template";
    CompanyNewsTileType["Video"] = "video";
})(CompanyNewsTileType || (CompanyNewsTileType = {}));
export var DealCategoryType;
(function (DealCategoryType) {
    DealCategoryType["Earn"] = "EARN";
    DealCategoryType["Spend"] = "SPEND";
    DealCategoryType["Free"] = "FREE";
})(DealCategoryType || (DealCategoryType = {}));
export var DealListSort;
(function (DealListSort) {
    DealListSort["Popularity"] = "popularity";
    DealListSort["Date"] = "date";
})(DealListSort || (DealListSort = {}));
export var DealPackagePaymentCountryCode;
(function (DealPackagePaymentCountryCode) {
    DealPackagePaymentCountryCode["Gb"] = "GB";
    DealPackagePaymentCountryCode["Fr"] = "FR";
    DealPackagePaymentCountryCode["Au"] = "AU";
    DealPackagePaymentCountryCode["Ie"] = "IE";
})(DealPackagePaymentCountryCode || (DealPackagePaymentCountryCode = {}));
export var DealPackageRegion;
(function (DealPackageRegion) {
    DealPackageRegion["En"] = "en";
    DealPackageRegion["Fr"] = "fr";
    DealPackageRegion["Au"] = "au";
    DealPackageRegion["Ire"] = "ire";
})(DealPackageRegion || (DealPackageRegion = {}));
export var DealSagaStep;
(function (DealSagaStep) {
    DealSagaStep["Error"] = "ERROR";
    DealSagaStep["Started"] = "STARTED";
    DealSagaStep["Order"] = "ORDER";
    DealSagaStep["Update"] = "UPDATE";
    DealSagaStep["Pay"] = "PAY";
    DealSagaStep["Complete"] = "COMPLETE";
    DealSagaStep["Aborted"] = "ABORTED";
    DealSagaStep["Refund"] = "REFUND";
})(DealSagaStep || (DealSagaStep = {}));
export var DealsListType;
(function (DealsListType) {
    DealsListType["Company"] = "COMPANY";
    DealsListType["NearMe"] = "NEAR_ME";
    DealsListType["Earn"] = "EARN";
    DealsListType["Spend"] = "SPEND";
})(DealsListType || (DealsListType = {}));
export var DealStatus;
(function (DealStatus) {
    DealStatus["On"] = "ON";
    DealStatus["Off"] = "OFF";
    DealStatus["Hidden"] = "HIDDEN";
    DealStatus["Test"] = "TEST";
    DealStatus["Archived"] = "ARCHIVED";
    DealStatus["Unavailable"] = "UNAVAILABLE";
})(DealStatus || (DealStatus = {}));
export var FraudThresholdType;
(function (FraudThresholdType) {
    FraudThresholdType["BusinessOrderAmount"] = "BUSINESS_ORDER_AMOUNT";
    FraudThresholdType["UserOrderCount"] = "USER_ORDER_COUNT";
})(FraudThresholdType || (FraudThresholdType = {}));
export var HomePageWidgetTypes;
(function (HomePageWidgetTypes) {
    HomePageWidgetTypes["Image"] = "image";
    HomePageWidgetTypes["ImageWithText"] = "imageWithText";
    HomePageWidgetTypes["Video"] = "video";
})(HomePageWidgetTypes || (HomePageWidgetTypes = {}));
export var InsRoomResolutionTypes;
(function (InsRoomResolutionTypes) {
    InsRoomResolutionTypes["Resolved"] = "RESOLVED";
    InsRoomResolutionTypes["Declined"] = "DECLINED";
    InsRoomResolutionTypes["Notapplicable"] = "NOTAPPLICABLE";
    InsRoomResolutionTypes["Unabletoresolve"] = "UNABLETORESOLVE";
    InsRoomResolutionTypes["Other"] = "OTHER";
})(InsRoomResolutionTypes || (InsRoomResolutionTypes = {}));
export var InsRoomStatus;
(function (InsRoomStatus) {
    InsRoomStatus["Active"] = "ACTIVE";
    InsRoomStatus["Closed"] = "CLOSED";
})(InsRoomStatus || (InsRoomStatus = {}));
export var InsRoomSubjectResourceTypes;
(function (InsRoomSubjectResourceTypes) {
    InsRoomSubjectResourceTypes["Comment"] = "COMMENT";
})(InsRoomSubjectResourceTypes || (InsRoomSubjectResourceTypes = {}));
export var InternalFeatureFlags;
(function (InternalFeatureFlags) {
    InternalFeatureFlags["GodModeFlag"] = "GodModeFlag";
    InternalFeatureFlags["CoreGroupsFullAccess"] = "CoreGroupsFullAccess";
    InternalFeatureFlags["CoreBusinessFullAccess"] = "CoreBusinessFullAccess";
    InternalFeatureFlags["CoreUsersFullAccess"] = "CoreUsersFullAccess";
    InternalFeatureFlags["AuthIAdminReadOnly"] = "AuthIAdminReadOnly";
    InternalFeatureFlags["AuthGhost"] = "AuthGhost";
    InternalFeatureFlags["AuthMfaManage"] = "AuthMFAManage";
    InternalFeatureFlags["AuthManageSessionsAndDevices"] = "AuthManageSessionsAndDevices";
    InternalFeatureFlags["OnboardingUserFullAccess"] = "OnboardingUserFullAccess";
    InternalFeatureFlags["OnboardingBusinessFullAccess"] = "OnboardingBusinessFullAccess";
    InternalFeatureFlags["OpenApiFullAccess"] = "OpenApiFullAccess";
    InternalFeatureFlags["ChannelPartnerFullAccess"] = "ChannelPartnerFullAccess";
    InternalFeatureFlags["PerksFullAccess"] = "PerksFullAccess";
    InternalFeatureFlags["InsightsFullAccess"] = "InsightsFullAccess";
    InternalFeatureFlags["MedicalFullAccess"] = "MedicalFullAccess";
    InternalFeatureFlags["RnRFullAccess"] = "RnRFullAccess";
    InternalFeatureFlags["ReportingFullAccess"] = "ReportingFullAccess";
    InternalFeatureFlags["TenantWalletFullAccess"] = "TenantWalletFullAccess";
    InternalFeatureFlags["ManageStockFullAccess"] = "ManageStockFullAccess";
    InternalFeatureFlags["ManageStockReadOnly"] = "ManageStockReadOnly";
    InternalFeatureFlags["ManagePaymentsFullAccess"] = "ManagePaymentsFullAccess";
    InternalFeatureFlags["V4RedemptionFullAccess"] = "V4RedemptionFullAccess";
})(InternalFeatureFlags || (InternalFeatureFlags = {}));
export var InternalLogActionType;
(function (InternalLogActionType) {
    InternalLogActionType["ResendWelcomeEmail"] = "ResendWelcomeEmail";
    InternalLogActionType["DeactivateTenantUsers"] = "DeactivateTenantUsers";
})(InternalLogActionType || (InternalLogActionType = {}));
export var ItemRedemptionStatus;
(function (ItemRedemptionStatus) {
    ItemRedemptionStatus["StatusUnknown"] = "STATUS_UNKNOWN";
    ItemRedemptionStatus["Pending"] = "PENDING";
    ItemRedemptionStatus["Completed"] = "COMPLETED";
    ItemRedemptionStatus["Failed"] = "FAILED";
    ItemRedemptionStatus["Refunded"] = "REFUNDED";
    ItemRedemptionStatus["Unrecognized"] = "UNRECOGNIZED";
})(ItemRedemptionStatus || (ItemRedemptionStatus = {}));
export var LayoutWidgetType;
(function (LayoutWidgetType) {
    LayoutWidgetType["Products"] = "products";
    LayoutWidgetType["Perks"] = "perks";
    LayoutWidgetType["CompanyNews"] = "companyNews";
})(LayoutWidgetType || (LayoutWidgetType = {}));
export var MarketingSubscriptionState;
(function (MarketingSubscriptionState) {
    MarketingSubscriptionState["Subscribed"] = "subscribed";
    MarketingSubscriptionState["Unsubscribed"] = "unsubscribed";
    MarketingSubscriptionState["OptedIn"] = "opted_in";
    MarketingSubscriptionState["Unrecognized"] = "UNRECOGNIZED";
})(MarketingSubscriptionState || (MarketingSubscriptionState = {}));
export var MerchantStatusEnum;
(function (MerchantStatusEnum) {
    MerchantStatusEnum["Active"] = "ACTIVE";
    MerchantStatusEnum["Inactive"] = "INACTIVE";
    MerchantStatusEnum["Suspended"] = "SUSPENDED";
    MerchantStatusEnum["Pending"] = "PENDING";
})(MerchantStatusEnum || (MerchantStatusEnum = {}));
export var PaymentCardType;
(function (PaymentCardType) {
    PaymentCardType["Amex"] = "amex";
    PaymentCardType["Mc"] = "mc";
    PaymentCardType["Visa"] = "visa";
})(PaymentCardType || (PaymentCardType = {}));
export var PaymentCurrencyType;
(function (PaymentCurrencyType) {
    PaymentCurrencyType["Gbp"] = "GBP";
    PaymentCurrencyType["Eur"] = "EUR";
    PaymentCurrencyType["Aud"] = "AUD";
})(PaymentCurrencyType || (PaymentCurrencyType = {}));
export var PaymentOrderStatus;
(function (PaymentOrderStatus) {
    PaymentOrderStatus["Pending"] = "PENDING";
    PaymentOrderStatus["Completed"] = "COMPLETED";
    PaymentOrderStatus["Failed"] = "FAILED";
    PaymentOrderStatus["Refunded"] = "REFUNDED";
    PaymentOrderStatus["PartRefunded"] = "PART_REFUNDED";
})(PaymentOrderStatus || (PaymentOrderStatus = {}));
export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Adyen"] = "ADYEN";
    PaymentProvider["AdyenClassic"] = "ADYEN_CLASSIC";
    PaymentProvider["Wallet"] = "WALLET";
    PaymentProvider["Zip"] = "ZIP";
})(PaymentProvider || (PaymentProvider = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Pending"] = "PENDING";
    PaymentStatus["Completed"] = "COMPLETED";
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["Refunded"] = "REFUNDED";
    PaymentStatus["PartRefunded"] = "PART_REFUNDED";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentWalletType;
(function (PaymentWalletType) {
    PaymentWalletType["Personal"] = "personal";
    PaymentWalletType["Rewards"] = "rewards";
})(PaymentWalletType || (PaymentWalletType = {}));
export var PerksHomepageLaneType;
(function (PerksHomepageLaneType) {
    PerksHomepageLaneType["Tag"] = "TAG";
    PerksHomepageLaneType["Company"] = "COMPANY";
    PerksHomepageLaneType["New"] = "NEW";
    PerksHomepageLaneType["Trending"] = "TRENDING";
    PerksHomepageLaneType["NearMe"] = "NEAR_ME";
    PerksHomepageLaneType["Spend"] = "SPEND";
    PerksHomepageLaneType["Earn"] = "EARN";
})(PerksHomepageLaneType || (PerksHomepageLaneType = {}));
export var PermisionsMedicalTiers;
(function (PermisionsMedicalTiers) {
    PermisionsMedicalTiers["Tier1"] = "TIER1";
    PermisionsMedicalTiers["Tier2"] = "TIER2";
    PermisionsMedicalTiers["Tier3"] = "TIER3";
})(PermisionsMedicalTiers || (PermisionsMedicalTiers = {}));
export var PermissionsRecognitionCreatePollOption;
(function (PermissionsRecognitionCreatePollOption) {
    PermissionsRecognitionCreatePollOption["AdminOnly"] = "ADMIN_ONLY";
    PermissionsRecognitionCreatePollOption["AdminAndManager"] = "ADMIN_AND_MANAGER";
    PermissionsRecognitionCreatePollOption["Everyone"] = "EVERYONE";
    PermissionsRecognitionCreatePollOption["Off"] = "OFF";
})(PermissionsRecognitionCreatePollOption || (PermissionsRecognitionCreatePollOption = {}));
export var PermissionsRecognitionSharingOption;
(function (PermissionsRecognitionSharingOption) {
    PermissionsRecognitionSharingOption["AdminOnly"] = "ADMIN_ONLY";
    PermissionsRecognitionSharingOption["AdminAndManager"] = "ADMIN_AND_MANAGER";
    PermissionsRecognitionSharingOption["Everyone"] = "EVERYONE";
    PermissionsRecognitionSharingOption["Off"] = "OFF";
})(PermissionsRecognitionSharingOption || (PermissionsRecognitionSharingOption = {}));
export var PermissionsRecognitionVisibilityOption;
(function (PermissionsRecognitionVisibilityOption) {
    PermissionsRecognitionVisibilityOption["On"] = "ON";
    PermissionsRecognitionVisibilityOption["Limited"] = "LIMITED";
    PermissionsRecognitionVisibilityOption["Off"] = "OFF";
})(PermissionsRecognitionVisibilityOption || (PermissionsRecognitionVisibilityOption = {}));
export var ProductSettingsMedicalTiers;
(function (ProductSettingsMedicalTiers) {
    ProductSettingsMedicalTiers["TierOne"] = "TierOne";
    ProductSettingsMedicalTiers["TierTwo"] = "TierTwo";
    ProductSettingsMedicalTiers["TierThree"] = "TierThree";
})(ProductSettingsMedicalTiers || (ProductSettingsMedicalTiers = {}));
export var ProductSettingsRecognitionValuesByRank;
(function (ProductSettingsRecognitionValuesByRank) {
    ProductSettingsRecognitionValuesByRank["Off"] = "Off";
    ProductSettingsRecognitionValuesByRank["TeamLeaderOnly"] = "TeamLeaderOnly";
    ProductSettingsRecognitionValuesByRank["TeamLeaderAndManager"] = "TeamLeaderAndManager";
    ProductSettingsRecognitionValuesByRank["Everyone"] = "Everyone";
})(ProductSettingsRecognitionValuesByRank || (ProductSettingsRecognitionValuesByRank = {}));
export var ProductSettingsRecognitionValuesByVisibility;
(function (ProductSettingsRecognitionValuesByVisibility) {
    ProductSettingsRecognitionValuesByVisibility["Hidden"] = "Hidden";
    ProductSettingsRecognitionValuesByVisibility["Limited"] = "Limited";
    ProductSettingsRecognitionValuesByVisibility["Visible"] = "Visible";
})(ProductSettingsRecognitionValuesByVisibility || (ProductSettingsRecognitionValuesByVisibility = {}));
export var ProductStockStatus;
(function (ProductStockStatus) {
    ProductStockStatus["Archived"] = "ARCHIVED";
    ProductStockStatus["Closed"] = "CLOSED";
    ProductStockStatus["Open"] = "OPEN";
    ProductStockStatus["Reserved"] = "RESERVED";
})(ProductStockStatus || (ProductStockStatus = {}));
export var QuestionSelectionTypeEnum;
(function (QuestionSelectionTypeEnum) {
    QuestionSelectionTypeEnum["EvenDistribution"] = "evenDistribution";
    QuestionSelectionTypeEnum["FirstInFirstOut"] = "firstInFirstOut";
})(QuestionSelectionTypeEnum || (QuestionSelectionTypeEnum = {}));
export var RedemptionEvents;
(function (RedemptionEvents) {
    RedemptionEvents["UsersDateOfBirth"] = "USERS_DATE_OF_BIRTH";
})(RedemptionEvents || (RedemptionEvents = {}));
export var RedemptionStatus;
(function (RedemptionStatus) {
    RedemptionStatus["Started"] = "STARTED";
    RedemptionStatus["Complete"] = "COMPLETE";
})(RedemptionStatus || (RedemptionStatus = {}));
export var ReportingFilterOption;
(function (ReportingFilterOption) {
    ReportingFilterOption["Team"] = "TEAM";
    ReportingFilterOption["PerkUuid"] = "PERK_UUID";
    ReportingFilterOption["PerkCategory"] = "PERK_CATEGORY";
    ReportingFilterOption["PerkType"] = "PERK_TYPE";
})(ReportingFilterOption || (ReportingFilterOption = {}));
export var ReportingPeriodGranularity;
(function (ReportingPeriodGranularity) {
    ReportingPeriodGranularity["D"] = "D";
    ReportingPeriodGranularity["W"] = "W";
    ReportingPeriodGranularity["M"] = "M";
})(ReportingPeriodGranularity || (ReportingPeriodGranularity = {}));
export var ReportingSegmentOption;
(function (ReportingSegmentOption) {
    ReportingSegmentOption["Team"] = "TEAM";
    ReportingSegmentOption["PerkUuid"] = "PERK_UUID";
    ReportingSegmentOption["PerkCategory"] = "PERK_CATEGORY";
    ReportingSegmentOption["PerkType"] = "PERK_TYPE";
})(ReportingSegmentOption || (ReportingSegmentOption = {}));
export var ScheduledTransferStatus;
(function (ScheduledTransferStatus) {
    ScheduledTransferStatus["NotActivated"] = "NOT_ACTIVATED";
    ScheduledTransferStatus["Cancelled"] = "CANCELLED";
    ScheduledTransferStatus["Pending"] = "PENDING";
    ScheduledTransferStatus["Failing"] = "FAILING";
    ScheduledTransferStatus["Failed"] = "FAILED";
})(ScheduledTransferStatus || (ScheduledTransferStatus = {}));
export var StockJobAction;
(function (StockJobAction) {
    StockJobAction["UpdateExpiry"] = "UPDATE_EXPIRY";
    StockJobAction["DeleteItems"] = "DELETE_ITEMS";
})(StockJobAction || (StockJobAction = {}));
export var StockJobStatus;
(function (StockJobStatus) {
    StockJobStatus["Done"] = "DONE";
    StockJobStatus["Failed"] = "FAILED";
    StockJobStatus["InProgress"] = "IN_PROGRESS";
})(StockJobStatus || (StockJobStatus = {}));
export var StockUsage;
(function (StockUsage) {
    StockUsage["Multiple"] = "MULTIPLE";
    StockUsage["Single"] = "SINGLE";
})(StockUsage || (StockUsage = {}));
export var SwitchboardAction;
(function (SwitchboardAction) {
    SwitchboardAction["SetPackage"] = "SET_PACKAGE";
    SwitchboardAction["SetMedicalTier"] = "SET_MEDICAL_TIER";
    SwitchboardAction["BlacklistDealIds"] = "BLACKLIST_DEAL_IDS";
    SwitchboardAction["BlacklistDealTags"] = "BLACKLIST_DEAL_TAGS";
    SwitchboardAction["EnableProductDeals"] = "ENABLE_PRODUCT_DEALS";
    SwitchboardAction["EnableProductRecognition"] = "ENABLE_PRODUCT_RECOGNITION";
    SwitchboardAction["EnableProductInsights"] = "ENABLE_PRODUCT_INSIGHTS";
    SwitchboardAction["EnableProductMedical"] = "ENABLE_PRODUCT_MEDICAL";
    SwitchboardAction["EnableProductTenantWallet"] = "ENABLE_PRODUCT_TENANT_WALLET";
    SwitchboardAction["EnableProductUserWallet"] = "ENABLE_PRODUCT_USER_WALLET";
    SwitchboardAction["EnableProductCultureHub"] = "ENABLE_PRODUCT_CULTURE_HUB";
    SwitchboardAction["DisableProductDeals"] = "DISABLE_PRODUCT_DEALS";
    SwitchboardAction["DisableProductRecognition"] = "DISABLE_PRODUCT_RECOGNITION";
    SwitchboardAction["DisableProductInsights"] = "DISABLE_PRODUCT_INSIGHTS";
    SwitchboardAction["DisableProductMedical"] = "DISABLE_PRODUCT_MEDICAL";
    SwitchboardAction["DisableProductTenantWallet"] = "DISABLE_PRODUCT_TENANT_WALLET";
    SwitchboardAction["DisableProductUserWallet"] = "DISABLE_PRODUCT_USER_WALLET";
    SwitchboardAction["DisableProductCultureHub"] = "DISABLE_PRODUCT_CULTURE_HUB";
    SwitchboardAction["DealsEnableCardlinked"] = "DEALS_ENABLE_CARDLINKED";
    SwitchboardAction["DealsDisableCardlinked"] = "DEALS_DISABLE_CARDLINKED";
    SwitchboardAction["DealsEnableGeo"] = "DEALS_ENABLE_GEO";
    SwitchboardAction["DealsDisableGeo"] = "DEALS_DISABLE_GEO";
    SwitchboardAction["RecognitionOptionSharing"] = "RECOGNITION_OPTION_SHARING";
    SwitchboardAction["RecognitionOptionViewReward"] = "RECOGNITION_OPTION_VIEW_REWARD";
    SwitchboardAction["RecognitionOptionAttachReward"] = "RECOGNITION_OPTION_ATTACH_REWARD";
    SwitchboardAction["RecognitionOptionCreatePoll"] = "RECOGNITION_OPTION_CREATE_POLL";
})(SwitchboardAction || (SwitchboardAction = {}));
export var TagKind;
(function (TagKind) {
    TagKind["DealCategory"] = "DealCategory";
    TagKind["DealCategories"] = "DealCategories";
    TagKind["DealTag"] = "DealTag";
    TagKind["DealPackage"] = "DealPackage";
    TagKind["DealLocationFilters"] = "DealLocationFilters";
    TagKind["DealLocationFilter"] = "DealLocationFilter";
    TagKind["DealPerksGoFilters"] = "DealPerksGoFilters";
    TagKind["DealPerksGoFilter"] = "DealPerksGoFilter";
    TagKind["RewardCategories"] = "RewardCategories";
    TagKind["RewardCategory"] = "RewardCategory";
    TagKind["RewardPackage"] = "RewardPackage";
})(TagKind || (TagKind = {}));
export var TeamState;
(function (TeamState) {
    TeamState["Generic"] = "Generic";
    TeamState["Protected"] = "Protected";
    TeamState["Deactivated"] = "Deactivated";
    TeamState["Deleted"] = "Deleted";
    TeamState["Ok"] = "OK";
    TeamState["Hidden"] = "HIDDEN";
    TeamState["Protected"] = "PROTECTED";
})(TeamState || (TeamState = {}));
export var TenantActivationStatus;
(function (TenantActivationStatus) {
    TenantActivationStatus["Activated"] = "ACTIVATED";
    TenantActivationStatus["Onhold"] = "ONHOLD";
    TenantActivationStatus["Deactivated"] = "DEACTIVATED";
})(TenantActivationStatus || (TenantActivationStatus = {}));
export var TenantAuditAction;
(function (TenantAuditAction) {
    TenantAuditAction["BulkResendWelcomeEmail"] = "BULK_RESEND_WELCOME_EMAIL";
    TenantAuditAction["Activated"] = "ACTIVATED";
    TenantAuditAction["Deactivated"] = "DEACTIVATED";
    TenantAuditAction["Onhold"] = "ONHOLD";
})(TenantAuditAction || (TenantAuditAction = {}));
export var TenantOnboardingStepStates;
(function (TenantOnboardingStepStates) {
    TenantOnboardingStepStates["Open"] = "OPEN";
    TenantOnboardingStepStates["Skipped"] = "SKIPPED";
    TenantOnboardingStepStates["Done"] = "DONE";
})(TenantOnboardingStepStates || (TenantOnboardingStepStates = {}));
export var UpsellRegion;
(function (UpsellRegion) {
    UpsellRegion["Gbr"] = "GBR";
    UpsellRegion["Ire"] = "IRE";
    UpsellRegion["Aus"] = "AUS";
    UpsellRegion["Fra"] = "FRA";
})(UpsellRegion || (UpsellRegion = {}));
export var UserAuditAction;
(function (UserAuditAction) {
    UserAuditAction["Activated"] = "ACTIVATED";
    UserAuditAction["Deactivated"] = "DEACTIVATED";
    UserAuditAction["EmailAddressChanged"] = "EMAIL_ADDRESS_CHANGED";
    UserAuditAction["RoleChanged"] = "ROLE_CHANGED";
})(UserAuditAction || (UserAuditAction = {}));
export var UserSource;
(function (UserSource) {
    UserSource["Upload"] = "Upload";
    UserSource["Push"] = "Push";
    UserSource["Pull"] = "Pull";
    UserSource["SignUp"] = "SignUp";
    UserSource["Legacy"] = "LEGACY";
    UserSource["Local"] = "LOCAL";
    UserSource["SelfCode"] = "SELF_CODE";
    UserSource["SelfEmail"] = "SELF_EMAIL";
    UserSource["Saml"] = "SAML";
})(UserSource || (UserSource = {}));
